import { LoadingCards } from "@/features/reassistRequests/components/StateBlocks";
import { MOBILE_BREAKPOINT } from "@/styles/responsive";

/** 一覧の読み込み中。画面が跳ねないよう、カードに近い高さ（角丸8）を確保する。 */
export const SaleListSkeleton: React.FC = () => (
  <LoadingCards rows={3} height={{ xs: 168, [MOBILE_BREAKPOINT]: 104 }} />
);
